import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Table } from '../Table';
import { INVOICES_TABLE_COLUMNS, INVOICE_HUB_TABLES, INVOICE_HUB_AUTOMATION_IDS } from '../../consts/consts';
import { useStore } from '../../../../../store';
import { buildQueryString, mapDataForInvoicesTable } from '../../utils';
import { useFetchInvoices } from '../../hooks/useFetchInvoices';
import { InvoiceHubContext } from '../../contexts/InvoiceHubContext';
import { HUB_MODALS } from '../InvoiceHubModals';

export const CanceledInvoicesTable = () => {
  const canceledPageNumber = useStore(state => state.canceledPageNumber);
  const paidInvoices = useStore(state => state.paidInvoices);
  const setCanceledPageNumber = useStore(state => state.setCanceledPageNumber);
  const canceledInvoices = useStore(state => state.canceledInvoices);
  const setCanceledInvoices = useStore(state => state.setCanceledInvoices);
  const setError = useStore(state => state.setError);
  const setActiveModal = useStore(state => state.setActiveModal);
  const [hasMoreToFetch, setHasMoreToFetch] = useState<boolean>(true);
  const { t } = useTranslation();
  const { refetch: fetchInvoices, isFetching } = useFetchInvoices({
    onSuccess: async (data: any) => {
      if (data?.invoices?.length === 0) {
        setHasMoreToFetch(false);
      } else {
        setCanceledInvoices(data.invoices, canceledPageNumber > 1);
      }
    },
    onError: (error: any) => {
      setError(error);
      setActiveModal(HUB_MODALS.ERROR);
    },
    queryString: buildQueryString(INVOICE_HUB_TABLES.CANCELED.name, canceledPageNumber),
    tableName: INVOICE_HUB_TABLES.CANCELED.name,
  });

  useEffect(() => {
    if (canceledInvoices?.length === 0) fetchInvoices();
  }, []);

  useEffect(() => {
    fetchInvoices();
  }, [canceledPageNumber]);

  useEffect(() => {
    setCanceledPageNumber(1);
    fetchInvoices();
  }, [paidInvoices]);

  const contextValue = useMemo(() => ({
    fetchMoreInvoices: () => {
      if (hasMoreToFetch) {
        setCanceledPageNumber(canceledPageNumber + 1);
      }
    },
  }), [canceledPageNumber]);
  const canceledInvoiceRows = useMemo(() => mapDataForInvoicesTable(INVOICE_HUB_TABLES.PAID.name, canceledInvoices), [canceledInvoices]);
  return (
    <InvoiceHubContext.Provider value={contextValue}>
      <div className='mt-[40px]'>
        <Table
          name={INVOICE_HUB_TABLES.CANCELED.name}
          title={`${t(INVOICE_HUB_TABLES.CANCELED.title)} (${canceledInvoiceRows?.length || 0})`}
          columns={INVOICES_TABLE_COLUMNS}
          data={canceledInvoiceRows}
          testId={INVOICE_HUB_AUTOMATION_IDS.HUB_TABLE_CANCELED}
          isLoading={isFetching && canceledPageNumber === 1}
        />
      </div>
    </InvoiceHubContext.Provider>
  );
};
